const defaultSettings = {
  apiBaseUrl: ""
};

let cachedSettings = { ...defaultSettings };

export async function loadAppSettings() {
  try {
    const response = await fetch("/appsettings.json", { cache: "no-store" });
    if (!response.ok) {
      throw new Error(`Failed to load appsettings.json (${response.status})`);
    }

    const parsed = await response.json();
    cachedSettings = {
      ...defaultSettings,
      ...parsed
    };
  } catch {
    cachedSettings = { ...defaultSettings };
  }
}

/**
 * In development, return "" so requests use the dev server origin; `proxy` in package.json
 * forwards /api to your API (no browser CORS). Production uses appsettings.json or REACT_APP_API_BASE_URL.
 */
export function getApiBaseUrl() {
  const fromEnv = process.env.REACT_APP_API_BASE_URL;
  if (fromEnv != null && String(fromEnv).trim() !== "") {
    return String(fromEnv).replace(/\/+$/, "");
  }
  if (process.env.NODE_ENV === "development") {
    return "";
  }
  const base = cachedSettings.apiBaseUrl ?? "";
  return typeof base === "string" ? base.replace(/\/+$/, "") : "";
}
